import { render, staticRenderFns } from "./QuestionsCatalog.vue?vue&type=template&id=0e81fa14&"
import script from "./QuestionsCatalog.vue?vue&type=script&lang=js&"
export * from "./QuestionsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuestionsCatalog.vue"
export default component.exports